<template>
    <div class="sms-message" v-html="cleanMessage" v-linkified:options="linkifiedOptions"></div>
</template>
<script>
export default {
    name: "SMSMessage",
    components: {},
    props: {
        message: {
            required: true,
        },
    },
    data() {
        return {
            linkifiedOptions: {
                truncate: 20,
                attributes: null,
                className: null,
                defaultProtocol: "https",
                events: null,
                format: {
                    url: (value) => (value.length > 20 ? value.slice(0, 20) + "…" : value),
                },
                formatHref: (href, type) => href,
                ignoreTags: [],
                nl2br: false,
                rel: null,
                tagName: "a",
                target: "_blank",
                validate: true,
            },
        }
    },
    computed: {
        cleanMessage() {
            return this.$sanitize(this.message)
        },
    },
}
</script>

<style lang="scss" scoped>
    .sms-message:deep {
        a {
            color: #ffffff !important;
        }
    }
</style>
